import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AlertsForm: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new My Broadcast Alerts page
    navigate("/alerts", { replace: true });
  }, [navigate]);

  return null; // This component will redirect immediately
};

export default AlertsForm;
